import { useCallback, useEffect } from 'react';
import { getLinkedProviders, linkGoogleAccount } from './authSession';

/** Warm Firebase Auth SDK so linkWithPopup stays inside the user-gesture window. */
function preloadFirebaseAuth() {
  void Promise.all([
    import('../config/firebase.js'),
    import('firebase/auth'),
  ]);
}

export function useLinkGoogleAccount() {
  useEffect(() => {
    preloadFirebaseAuth();
  }, []);

  const isGoogleLinked = useCallback(async () => {
    const providers = await getLinkedProviders();
    return providers.some((pr) => pr.id === 'google.com');
  }, []);

  const linkGoogle = useCallback(async () => {
    await linkGoogleAccount();
    return getLinkedProviders();
  }, []);

  return { isGoogleLinked, linkGoogle };
}
